(function ($) {
    var opt = $.extend({ajaxUrl: ''}, window.hasOwnProperty('cheilSearch') ? window.cheilSearch : {}),
        relatedKeywords = null;

    $.fn.cheilSearchForm = function () {
        var self = this,
            search = $('.auto-search', self),
            input = $('input[type="search"]', self),
            items = 0,
            completed = false;

        function find() {
            var kw = input.val().replace(/^"/, '');

            if (null !== relatedKeywords) {
                items = [];
                if (kw.length >= 2) {
                    _.each(relatedKeywords, function (item) {
                        if (item.toLowerCase().indexOf(kw) > -1) {
                            items.push(item);
                        }
                    });
                }
            } else {
                $.get(opt.ajaxUrl, {
                    action: 'cheil_related_keywords'
                }, function (response) {
                    if (response.success) {
                        relatedKeywords = response.data;
                    }
                });
            }
        }

        function render() {
            var html = '';
            _.each(items, function (item) {
                html += '<a href="#" class="dropdown-item">' + item + '</a>';
            });
            search.html(html);
            if (html.length) {
                search.addClass('show');
            } else {
                search.removeClass('show');
            }
        }

        input.on('keyup', function (e) {
            if (e.key === 'Escape') {
                search.removeClass('show');
                return;
            }
            completed = false;
            find(e.currentTarget.value.toLowerCase());
            render();
        }).on('keydown mousedown', function () {
            if (input.val().length && !completed) {
                find();
                render();
            }
        });

        search.on('click', 'a.dropdown-item', function (e) {
            e.preventDefault();
            input.val('"' + e.currentTarget.innerText + '"');
            search.removeClass('show');
            search.html('');
            completed = true;
        });

        return this;
    };

    $('.search-keywords').on('click', 'a', function (e) {
        var form = $(document.getElementById(e.currentTarget.dataset.form)),
            s = form.find('input[type="search"]'),
            keyword = e.currentTarget.dataset.keyword;

        if (keyword.length && s.length) {
            s.val('"' + keyword + '"');
        }

        e.preventDefault();
    });

    $(document).ready(function () {
        $('form.search-form').each(function (idx, elem) {
            $(elem).cheilSearchForm();
        });
    });
})(jQuery);
